import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={17}
    height={17}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.083 2.125H2.125v4.958h4.958V2.125ZM14.875 2.125H9.916v4.958h4.959V2.125ZM14.875 9.918H9.916v4.958h4.959V9.918ZM7.083 9.918H2.125v4.958h4.958V9.918Z"
      stroke="#ffffff"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgComponent;
